const DATA_ENGINE_URL = window._env_?.REACT_APP_DATA_ENGINE_URL || 'http://localhost:8002';
const AGENT_URL = window._env_?.REACT_APP_TEMPLATE_AGENT_URL || 'http://localhost:8001';

export const reportApi = {
  // Models
  getModels: () => fetch(`${AGENT_URL}/models`).then(r => r.json()),

  // CRUD
  listReports: (orgId = 'default') =>
    fetch(`${DATA_ENGINE_URL}/api/reports?org_id=${orgId}`).then(r => r.json()),
  getReport: (id) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/${id}`).then(r => r.json()),
  createFromPreset: (data) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/from-preset`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),
  updateReport: (id, data) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/${id}`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),
  deleteReport: (id) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/${id}`, { method: 'DELETE' }).then(r => r.json()),
  forkReport: (id, data) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/fork/${id}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),

  // Execution
  executeReport: (id, params = {}, rfIds = null) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/${id}/execute`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ parameters: params, ...(rfIds ? { rf_ids: rfIds } : {}) }),
    }).then(r => r.json()),
  executeByType: (data) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/execute-by-type`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),

  // Reconciliation
  reconcileReport: (id, data = {}) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/${id}/reconcile`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),
  reconcileByType: (data) =>
    fetch(`${DATA_ENGINE_URL}/api/reports/reconcile-by-type`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),

  // Agent chat
  streamChat: (body, signal) =>
    fetch(`${AGENT_URL}/chat/report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
      body: JSON.stringify(body),
      signal,
    }),
};
